module.exports = __webpack_public_path__ + "static/media/eafit_logo.deaccf4e.png";